import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Overview from '../../pages/overview';
import Orders from '../../pages/orders';
import UsersPage from '../../pages/clients/index';
import ProductsStats from '../../pages/products/ProductsStats';
import Documents from '../../pages/documents';
import ProductImages from '../../pages/products/ProductImages';
import Profile from '../../pages/settings/Profile';
import AccountSettings from '../../pages/settings/Account';
import AccountSignIn from '../../pages/settings/account/SignIn';
import Notifications from '../../pages/settings/Notifications';
import Billings from '../../pages/settings/Billings';

export default function PrivateInAppRoutes() {
    return (
        <div>
            <Switch>
                <Route
                    exact
                    path="/dashboard/:userId/overview"
                    component={Overview}
                />
                <Route
                    exact
                    path="/dashboard/:userId/clients"
                    component={UsersPage}
                />
                <Route
                    exact
                    path="/dashboard/:userId/orders"
                    component={Orders}
                />
                <Route
                    exact
                    path="/dashboard/:userId/orders/:id"
                    component={Orders}
                />
                <Route
                    exact
                    path="/dashboard/:userId/products/stats"
                    component={ProductsStats}
                />
                 <Route
                    exact
                    path="/dashboard/:userId/products/images"
                    component={ProductImages}
                />
                <Route
                    exact
                    path="/dashboard/:userId/documents"
                    component={Documents}
                />
                <Route
                    exact
                    path="/dashboard/:userId/settings/profile"
                    component={Profile}
                />
                <Route
                    exact
                    path="/dashboard/:userId/settings/account"
                    component={AccountSettings}
                />
                <Route
                    exact
                    path="/dashboard/:userId/settings/billings"
                    component={Billings}
                />
                <Route
                    exact
                    path="/dashboard/:userId/settings/sign-in"
                    component={AccountSignIn}
                />
                <Route
                    exact
                    path="/dashboard/:userId/settings/notifications"
                    component={Notifications}
                />
            </Switch>
        </div>
    )
}